import { requiredSIPForTarget, requiredStpForTarget } from "../../engine/calculations";

const config = {
  key: "req-sip-or-stp",
  title: "SIP / STP Required for Target FV",
  category: "Target-Based",
  description: "Compare a direct monthly SIP against a Systematic Transfer Plan to reach the same target.",
  fields: [
    { key: "targetFV", label: "Target future value", type: "currency", default: 25_00_000, min: 1000, max: 100_00_00_000 },
    { key: "sourceRate", label: "Source fund return (for STP)", type: "percent", default: 7, min: 0, max: 20, assumptionKey: "debtReturn" },
    { key: "targetRate", label: "Target fund return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
    { key: "months", label: "Period (months)", type: "number", default: 36, min: 1, max: 480 },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const targetFV = Number(values.targetFV) || 0;
    const sourceRate = (Number(values.sourceRate) || 0) / 100;
    const targetRate = (Number(values.targetRate) || 0) / 100;
    const months = Math.round(Number(values.months) || 0);

    const requiredSIP = requiredSIPForTarget(targetFV, targetRate, months);
    const requiredStp = requiredStpForTarget(targetFV, sourceRate, targetRate, months);

    return {
      headline: { label: "Required Monthly SIP", value: requiredSIP },
      extraHeadlines: [{ label: "Or, Required Monthly STP Transfer", value: requiredStp }],
      breakdown: [{ label: "Target future value", value: targetFV }],
      series: [
        { name: "Direct SIP", amount: requiredSIP },
        { name: "STP transfer", amount: requiredStp },
      ],
    };
  },
};

export default config;
